import { CSSProperties, StyleSheet } from 'aphrodite';
import {
	brandPrimaryHover,
	destructive,
	grayIconFill,
	kitTintColor,
	navigation,
	noteTintColor,
	success,
	urgentDate,
} from '../../../../web/styles/colors';
import { CssSelectors, DefaultBorder, baseStyles, truncateTextStyle } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	accountName: {
		color: brandPrimaryHover,
		cursor: 'pointer',
		fontSize: 16,
		fontWeight: 600,
		textDecoration: 'none',
		width: 280,
	},
	accountNameHC: {
		width: 280,
		...truncateTextStyle,
	},
	cancelled: {
		color: navigation,
		fontSize: 12,
		minWidth: 50,
		...truncateTextStyle,
	},
	container: {
		alignItems: 'center',
		borderTop: DefaultBorder,
		gap: 8,
		display: 'flex',
		minHeight: 60,
	},
	rowContainerInner: {
		flex: 1,
		display: `flex`,
		alignItems: `center`,
		justifyContent: 'space-between',
		color: '#000',
		fontSize: 14,
	},
	csm: {
		alignItems: 'center',
		display: 'flex',
		gap: 6,
		width: 100,
	},
	csmEditBtn: {
		opacity: 0,
		pointerEvents: 'none',
		transition: 'opacity 0.15s',
		':is(:where(.group):hover *)': {
			opacity: 0.7,
			pointerEvents: 'auto',
		},
		':hover': {
			opacity: 1,
		},
	},
	deleteSnapshot: {
		cursor: 'pointer',
		opacity: 0,
		pointerEvents: 'none',
		transition: 'opacity 0.15s',
		':is(:where(.group):hover *)': {
			opacity: 1,
			pointerEvents: 'auto',
		},
	},
	dim: {
		...CssSelectors.allDescendants(
			{
				opacity: 0.3,
			},
			'div'
		),
	},
	disablePointer: {
		cursor: 'unset',
	},
	grayProbability: {
		color: grayIconFill,
	},
	green: {
		backgroundColor: success,
	},
	greenProbability: {
		color: success,
	},
	mrr: {
		fontWeight: 700,
	},
	orange: {
		backgroundColor: '#FF8B27',
	},
	pastDue: {
		color: urgentDate,
		fontSize: 12,
		minWidth: 50,
		...truncateTextStyle,
	},
	columnItem: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		minWidth: 70,
	},
	probabilityInput: {
		':focus-within': {
			border: '1px solid #00AAE8',
			outline: 'none',
		},
		flexShrink: 0,
		width: 68,
	},
	// The shared Input is border-box, so the border and padding come out of the space the value gets.
	// Its 12px side padding is trimmed here to leave room for three digits alongside the number
	// spin buttons, which the renewal rows rely on for nudging a percentage.
	probabilityInputText: {
		padding: '4px 8px',
		width: 68,
	},
	percentagePrev: {
		marginRight: 8,
	},
	red: {
		backgroundColor: destructive,
	},
	redProbability: {
		color: destructive,
	},
	renewalDate: {
		minWidth: 60,
	},
	renewalPdfSent: {
		display: 'flex',
		justifyContent: 'center',
		minWidth: 60,
	},
	selectTrigger: {
		...(baseStyles.textField as CSSProperties),
		height: 41,
		minWidth: 145,
	},
	stage: {
		minWidth: 145,
	},
	stageSpinner: {
		width: 145,
	},
	status: {
		borderRadius: 6,
		display: 'inline-block',
		height: 12,
		marginRight: 6,
		width: 12,
	},
	unassigned: {
		color: kitTintColor,
	},
	yellow: {
		backgroundColor: noteTintColor,
	},
});
